var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/EstimationApi/EstimationRepo/estimationConnect.ts";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import * as api from './api';
export function estimationConnect(estimationFetch) {
  api.EstimationRepo.Populated.fetch.use(function (_ref) {
    var projectUrn = _ref.projectUrn;
    return estimationFetch.get("/v1/estimation-repo/project/".concat(projectUrn)).then(api.EstimationRepo.Populated.fetch.toPromise);
  });
  api.EstimationRepoFolder.create.use(function (_ref2) {
    var parentFolderId = _ref2.parentFolderId,
        name = _ref2.name,
        projectUrn = _ref2.projectUrn;
    return estimationFetch.post("/v1/estimation-repo/project/".concat(projectUrn, "/folder"), {
      parentFolderId: parentFolderId,
      name: name
    }).then(api.EstimationRepoFolder.create.toPromise);
  });
  api.EstimationRepoFolder.Populated.fetch.use(function (_ref3) {
    var id = _ref3.id;
    return estimationFetch.get("/v1/estimation-repo/folder/".concat(id)).then(api.EstimationRepoFolder.Populated.fetch.toPromise);
  });
  api.EstimationRepoFolder.Populated.fetchSilent.use(function (_ref4) {
    var id = _ref4.id;
    return estimationFetch.get("/v1/estimation-repo/folder/".concat(id), {
      skip403: true
    }).then(api.EstimationRepoFolder.Populated.fetchSilent.toPromise);
  });
  api.EstimationRepoFolder.rename.use(function (_ref5) {
    var id = _ref5.id,
        name = _ref5.name,
        parentFolderId = _ref5.parentFolderId;
    return estimationFetch.patch("/v1/estimation-repo/folder/".concat(id), {
      name: name,
      parentFolderId: parentFolderId
    }).then(api.EstimationRepoFolder.rename.toPromise);
  });
  api.EstimationRepoFolder.move.use(function (_ref6) {
    var id = _ref6.id,
        parentFolderId = _ref6.parentFolderId;
    return estimationFetch.patch("/v1/estimation-repo/folder/".concat(id), {
      parentFolderId: parentFolderId
    }).then(api.EstimationRepoFolder.move.toPromise);
  });
  api.EstimationRepoFolder.remove.use(function (_ref7) {
    var id = _ref7.id;
    return estimationFetch["delete"]("/v1/estimation-repo/folder/".concat(id)).then(api.EstimationRepoFolder.remove.toPromise);
  });
  api.Estimation.create.use(function (_ref8) {
    var parentFolderId = _ref8.parentFolderId,
        name = _ref8.name,
        projectUrn = _ref8.projectUrn;
    return estimationFetch.post("/v1/estimation-repo/project/".concat(projectUrn, "/estimation"), {
      parentFolderId: parentFolderId,
      name: name
    }).then(api.Estimation.create.toPromise);
  });
  api.Estimation.copy.use(function (_ref9) {
    var id = _ref9.id,
        name = _ref9.name,
        version = _ref9.version;
    return estimationFetch.post("/v1/estimation-repo/estimation/".concat(id, "/version/").concat(version, "/copy"), {
      name: name
    }).then(api.Estimation.create.toPromise);
  });
  api.Estimation.rename.use(function (_ref10) {
    var id = _ref10.id,
        name = _ref10.name,
        parentFolderId = _ref10.parentFolderId,
        version = _ref10.version;
    return estimationFetch.patch("/v1/estimation-repo/estimation/".concat(id, "/version/").concat(version), {
      name: name,
      parentFolderId: parentFolderId
    }).then(api.Estimation.rename.toPromise);
  });
  api.Estimation.move.use(function (_ref11) {
    var id = _ref11.id,
        parentFolderId = _ref11.parentFolderId,
        version = _ref11.version;
    return estimationFetch.patch("/v1/estimation-repo/estimation/".concat(id, "/version/").concat(version), {
      parentFolderId: parentFolderId
    }).then(api.Estimation.move.toPromise);
  });
  api.Estimation.remove.use(function (_ref12) {
    var id = _ref12.id;
    return estimationFetch["delete"]("/v1/estimation-repo/estimation/".concat(id)).then(api.Estimation.remove.toPromise);
  });
  api.Estimation.getMostRecent.use(function (_ref13) {
    var id = _ref13.id;
    return estimationFetch.get("/v1/estimation-repo/estimation/".concat(id, "/most-recent")).then(api.Estimation.getMostRecent.toPromise);
  });
  api.Estimation.getMostRecentSilent.use(function (_ref14) {
    var id = _ref14.id;
    return estimationFetch.get("/v1/estimation-repo/estimation/".concat(id, "/most-recent")).then(api.Estimation.getMostRecentSilent.toPromise);
  });
  api.Estimation.fetch.use(function (_ref15) {
    var id = _ref15.id,
        version = _ref15.version;
    return estimationFetch.get("/v1/estimation-repo/estimation/".concat(id, "/version/").concat(version)).then(api.Estimation.fetch.toPromise);
  });
  api.EstimationCalculation.updateFields.use(function (_ref16) {
    var estimationId = _ref16.estimationId,
        simpleFields = _ref16.simpleFields,
        estimationVersion = _ref16.estimationVersion,
        calculationId = _ref16.calculationId,
        complexFields = _ref16.complexFields;
    return estimationFetch.patch("/v1/estimation-repo/estimation/".concat(estimationId, "/version/").concat(estimationVersion, "/calculation/").concat(calculationId), {
      simpleFields: simpleFields,
      complexFields: complexFields
    }).then(api.EstimationCalculation.updateFields.toPromise);
  });
  api.EstimationCalculation.validateFormula.use(function (_ref17) {
    var formula = _ref17.formula;
    return estimationFetch.post("/v1/estimation-repo/validate-estimation-calculation-formula", {
      formula: formula
    }).then(api.EstimationCalculation.validateFormula.toPromise);
  });
  api.EstimationCalculation.create.use(function (_ref18) {
    var estimationId = _ref18.estimationId,
        estimationVersion = _ref18.estimationVersion,
        groupId = _ref18.groupId,
        simpleFields = _ref18.simpleFields,
        complexFields = _ref18.complexFields;
    return estimationFetch.post("/v1/estimation-repo/estimation/".concat(estimationId, "/version/").concat(estimationVersion, "/calculation"), {
      groupId: groupId,
      simpleFields: simpleFields,
      complexFields: complexFields
    }).then(api.EstimationCalculation.create.toPromise);
  });
  api.EstimationCalculation.remove.use(function (_ref19) {
    var estimationId = _ref19.estimationId,
        estimationVersion = _ref19.estimationVersion,
        calculationId = _ref19.calculationId;
    return estimationFetch["delete"]("/v1/estimation-repo/estimation/".concat(estimationId, "/version/").concat(estimationVersion, "/calculation/").concat(calculationId)).then(api.EstimationCalculation.remove.toPromise);
  });
  api.Estimation.fetchStatus.use(function (_ref20) {
    var estimationId = _ref20.estimationId,
        estimationVersion = _ref20.estimationVersion;
    return estimationFetch.get("/v1/estimation-calculation/estimation/".concat(estimationId, "/version/").concat(estimationVersion, "/status")).then(api.Estimation.fetchStatus.toPromise);
  });
  api.Estimation.changeStatus.use(function (_ref21) {
    var estimationId = _ref21.estimationId,
        estimationVersion = _ref21.estimationVersion,
        body = _objectWithoutProperties(_ref21, ["estimationId", "estimationVersion"]);

    return estimationFetch.post("/v1/estimation-repo/estimation/".concat(estimationId, "/version/").concat(estimationVersion, "/status"), body).then(api.Estimation.changeStatus.toPromise);
  });
  api.Estimation.start.use(function (_ref22) {
    var estimationId = _ref22.estimationId,
        estimationVersion = _ref22.estimationVersion;
    return estimationFetch.post("/v1/estimation-calculation/start", {
      estimationId: estimationId,
      estimationVersion: estimationVersion
    }).then(api.Estimation.start.toPromise);
  });
  api.Estimation.modelElementEstimationStatus.use(function (_ref23) {
    var estimationId = _ref23.estimationId,
        estimationVersion = _ref23.estimationVersion,
        modelId = _ref23.modelId;
    return estimationFetch.get("/v1/estimation-repo/estimation/".concat(estimationId, "/version/").concat(estimationVersion, "/model/").concat(modelId, "/model-element-estimation-status")).then(api.Estimation.modelElementEstimationStatus.toPromise);
  });
  api.Estimation.fetchVersionDates.use(function (_ref24) {
    var estimationId = _ref24.estimationId;
    return estimationFetch.get("/v1/estimation-repo/estimation/".concat(estimationId, "/version/date")).then(api.Estimation.fetchVersionDates.toPromise);
  });
  api.Estimation.fetchVersionByDate.use(function (_ref25) {
    var estimationId = _ref25.estimationId,
        versionDate = _ref25.versionDate;
    return estimationFetch.get("/v1/estimation-repo/estimation/".concat(estimationId, "/version/date/").concat(versionDate)).then(api.Estimation.fetchVersionByDate.toPromise);
  });
  api.Estimation.renameVersion.use(function (_ref26) {
    var estimationId = _ref26.estimationId,
        estimationVersion = _ref26.estimationVersion,
        versionName = _ref26.versionName;
    return estimationFetch.post("/v1/estimation-repo/estimation/".concat(estimationId, "/version/").concat(estimationVersion, "/name"), {
      versionName: versionName
    }).then(api.Estimation.renameVersion.toPromise);
  });
  api.Estimation.removeVersionName.use(function (_ref27) {
    var estimationId = _ref27.estimationId,
        estimationVersion = _ref27.estimationVersion;
    return estimationFetch["delete"]("/v1/estimation-repo/estimation/".concat(estimationId, "/version/").concat(estimationVersion, "/name")).then(api.Estimation.removeVersionName.toPromise);
  });
  api.Estimation.fetchNamedVersions.use(function (_ref28) {
    var estimationId = _ref28.estimationId;
    return estimationFetch.get("/v1/estimation-repo/estimation/".concat(estimationId, "/version/name")).then(api.Estimation.fetchNamedVersions.toPromise);
  });
  api.Estimation.ImportEstimation.use(function (_ref29) {
    var estimationId = _ref29.estimationId,
        estimationVersion = _ref29.estimationVersion,
        sourceEstimationId = _ref29.sourceEstimationId,
        sourceEstimationVersion = _ref29.sourceEstimationVersion,
        sourceProjectUrn = _ref29.sourceProjectUrn;
    return estimationFetch.post("/v1/estimation-repo/estimation/".concat(estimationId, "/version/").concat(estimationVersion, "/template"), {
      sourceEstimationId: sourceEstimationId,
      sourceEstimationVersion: sourceEstimationVersion,
      sourceProjectUrn: sourceProjectUrn
    }).then(api.Estimation.ImportEstimation.toPromise);
  });
}